import classNames from 'classnames';
import differenceInDays from 'date-fns/differenceInDays';
import formatDistanceToNowStrict from 'date-fns/formatDistanceToNowStrict';
import parseISO from 'date-fns/parseISO';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import dateLocale from '../../lib/dateLocale';

import DurationTypo from '../typography/Duration';

import styles from '../../styles/partials/time.module.css';

const propTypes = {
    date: PropTypes.string.isRequired,
    textOnly: PropTypes.bool,
    withoutRelative: PropTypes.bool,
    month: PropTypes.string,
    day: PropTypes.string,
    year: PropTypes.string,
    weekday: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    textOnly: false,
    withoutRelative: false,
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    weekday: undefined,
    className: null,
};

function Time({ date, month, day, year, weekday, textOnly, withoutRelative, className }) {
    const intl = useIntl();
    const time = useMemo(() => {
        const dateObj = parseISO(date);
        const now = new Date();
        const days = differenceInDays(now, dateObj);
        if (days === 1 && !withoutRelative) {
            return intl.formatMessage({
                defaultMessage: 'Hier',
                description: 'Time label',
            });
        }
        if (now.getFullYear() !== dateObj.getFullYear()) {
            return intl.formatDate(dateObj, {
                weekday,
                month,
                day,
                year,
            });
        }
        return days >= 2 || withoutRelative
            ? intl.formatDate(dateObj, {
                  weekday,
                  month,
                  day,
              })
            : formatDistanceToNowStrict(dateObj, { locale: dateLocale, addSuffix: true });
    }, [intl, date, month, withoutRelative, day, year, weekday]);
    return textOnly ? (
        time
    ) : (
        <DurationTypo
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {time}
        </DurationTypo>
    );
}

Time.propTypes = propTypes;
Time.defaultProps = defaultProps;

export default Time;
